import axios from "axios";


const urls = {
    live: "https://api.ecoshoppegh.com",
    development: "http://localhost:5000"
}

export const baseURL = urls.live

export const Axios = axios.create({
    baseURL: `${baseURL}/admin`,
    withCredentials: true,
})